import { useTheme } from '@fluentui/react';
import { IPSpinner, IPText } from 'baseComponents';
import { IPProgressIndicator } from 'baseComponents/ProgressIndicator/IPProgressIndicator';
import { IPSpinnerSize } from 'baseComponents/Spinner/IPSpinner';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalCssVarSurfaceOverlay, globalStackTokensGapSmall } from 'globalStyles';
import { useTranslation } from 'react-i18next';

export interface IOverlayLoaderProps {
  text?: string;
  showProgress?: boolean;
  progressPercent?: number;
  progressLabel?: string;
  height?: number;
  width?: number;
}

const OverlayLoader = (props: IOverlayLoaderProps) => {
  const { t } = useTranslation(['translation']);
  const theme = useTheme();
  const width = props.width ?? (props.showProgress ? 400 : undefined);
  const height = props.height ?? (props.showProgress ? 180 : undefined);

  //if both text and progressLabel are not provided, show a default text
  const textToDisplay =
    !props.text && !props.progressLabel ? t('translation:General.Notifications.Loading') : props.text;

  return (
    <IPStack
      verticalFill
      className="isoplanner-overlay-loader"
      styles={{
        root: {
          position: 'absolute',
          margin: 'auto',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 99999999,
        },
      }}
      horizontalAlign="center"
      verticalAlign="center"
    >
      <IPStack
        styles={{
          root: {
            padding: 20,
            minWidth: width,
            minHeight: height,
            maxWidth: width,
            maxHeight: height,
            overflow: 'hidden',
            background: globalCssVarSurfaceOverlay,
            border: `1px solid ${theme.semanticColors.bodyDivider}`,
            borderRadius: 8,
            boxShadow: theme.effects.elevation64,
          },
        }}
        tokens={globalStackTokensGapSmall}
      >
        <IPStack.Item>
          <IPSpinner styles={{ root: { paddingBottom: !props.text ? 25 : undefined } }} size={IPSpinnerSize.large} />
        </IPStack.Item>
        {textToDisplay && (
          <IPStack.Item>
            <IPText>{textToDisplay}</IPText>
          </IPStack.Item>
        )}
        {props.showProgress && (
          <IPStack>
            {props.progressLabel && (
              <IPStack.Item>
                <IPText block nowrap>
                  {props.progressLabel}
                </IPText>
              </IPStack.Item>
            )}
            <IPStack horizontal tokens={globalStackTokensGapSmall} verticalAlign="center">
              <IPStack.Item grow>
                <IPProgressIndicator barHeight={6} percentComplete={props.progressPercent} />
              </IPStack.Item>
              <IPStack.Item styles={{ root: { minWidth: 35 } }}>
                <IPText>{`${Math.round((props.progressPercent ?? 0) * 100)}%`}</IPText>
              </IPStack.Item>
            </IPStack>
          </IPStack>
        )}
      </IPStack>
    </IPStack>
  );
};

export default OverlayLoader;
